"use client";
import React from "react";
import { FiInstagram, FiArrowRight, FiHeart, FiMessageCircle, FiSend } from 'react-icons/fi';

const InstagramBanner = () => {
  // On simule des posts avec des icônes et des dégradés pour le style
  const slides = [
    { id: 1, color: "from-[#f09433] to-[#ed017f]", icon: <FiHeart /> },
    { id: 2, color: "from-[#ed017f] to-[#bc1888]", icon: <FiMessageCircle /> },
    { id: 3, color: "from-[#bc1888] to-[#405de6]", icon: <FiSend /> },
    { id: 4, color: "from-[#405de6] to-[#f09433]", icon: <FiInstagram /> },
  ];

  return (
    <section className="w-full py-12 sm:py-20 overflow-hidden flex flex-col items-center justify-center">
      <div className="max-w-5xl w-full px-4">

        {/* Titre Principal Centré */}
        <div className="max-w-3xl mx-auto mb-8 sm:mb-12 text-center">
          <h2 className="text-2xl sm:text-3xl md:text-5xl lg:text-6xl font-black text-[#343434] leading-tight mb-4 sm:mb-6 capitalize">
            Rejoignez la Communauté <br />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#f09433] via-[#ed017f] to-[#bc1888]">
              @parex_tunisie
            </span>
          </h2>
          <p className="text-gray-500 font-medium text-sm sm:text-base md:text-lg max-w-xl mx-auto">
            Découvrez nos projets, nos conseils et les coulisses de Parex en un clic.
          </p>
        </div>

        {/* Slider Centré (mobile: horizontal scroll, desktop: centered grid) */}


        {/* CTA Button Final */}
        <div className="flex w-full justify-center">
          <a
            href="https://www.instagram.com/parex_tunisie"
            target="_blank"
            rel="noopener noreferrer"
            className="group relative inline-flex items-center justify-center px-6 sm:px-10 py-3 sm:py-4 w-full sm:w-auto max-w-xs font-bold text-white transition-all duration-300 bg-gradient-to-r from-[#f09433] via-[#ed017f] to-[#bc1888] rounded-2xl hover:bg-gradient-to-r from-[#f09433] via-[#ed017f] to-[#bc1888] hover:shadow-2xl hover:shadow-pink-500/20 active:scale-95"
          >
            <FiInstagram className="mr-2 text-lg sm:text-xl" />
            <span>Suivre Parex Tunisie</span>
            <FiArrowRight className="ml-2 transform group-hover:translate-x-1 transition-transform" />
          </a>
        </div>
      </div>

      {/* Styles pour masquer la scrollbar et animations */}
      <style jsx global>{`
        .scrollbar-hide::-webkit-scrollbar {
          display: none;
        }
        .scrollbar-hide {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
        @keyframes fade-in {
          from { opacity: 0; transform: translateY(10px); }
          to { opacity: 1; transform: translateY(0); }
        }
        .animate-fade-in {
          animation: fade-in 0.8s ease-out forwards;
        }
      `}</style>
    </section>
  );
};

export default InstagramBanner;